"use client";
import ToolsStack from "@/components/section-infographic/DesignAndDevelopmentAsAService/ToolsStack";
import CaseStudiesMutiPurposeZigZagSection from "@/components/ui/CaseStudiesMutiPurposeZigZagSection";
import CaseStudyEngageMentModel from "@/components/ui/CaseStudyEngageMentModel";
import CommentSection from "@/components/ui/CommentSection";
import CTABanner from "@/components/organisms/CTABanner";
import VideoSection from "@/components/ui/VideoSection";

import CaseStudiesIntroBanner from "@/components/ui/CaseStudiesIntroBanner";
import CaseStudiesNewMegaCardSection from "@/components/ui/CaseStudiesNewMegaCarSection";
import CaseStudiesSkewSatusCardsSection from "@/components/ui/CaseStudiesSkewSatusCardsSection";
import ImageMarquee from "@/components/ui/ImageMarquee";
import SectionTitle from "@/components/ui/SectionTitle";
import IndustryHero from "@/components/SectionHero/IndustryHero";

import RelatedCaseStudies from "@/components/ui/RelatedCaseStudies";
import UniversalTable from "@/components/UniversalTable";
import TheChallengeScrollSection from "@/components/ui/TheChallengeScrollSection";
import RedRibbonBanner from "@/components/ui/RedRibbonBanner";



export default function BoardGamesCasestudyPage() {



    const clients = [

        {
            label: "CLIENT",
            name: "Smart Delivery",

        },
        {
            label: "INDUSTRY",
            name: "Delivery / Logistics / On-Demand Services",

        },
        {
            label: "Engagement Type",
            description: "Growth-as-a-Service: SEO & SMO",
        },


    ];

    const skewCards = [
        {
            title: "3.1x",
            description: "Increase in Organic Website Traffic",
        },
        {
            title: "291%",
            description: "Increase in Google Search Impressions",
        },
        {
            title: "214",
            description: "Ranking Keywords Achieved",
        },
        {
            title: "1,180",
            description: "Total Backlinks Generated",
        },
        {
            title: "138%",
            description: "Increase in Map Visibility",
        },
    ];


    return (
        <main className="overflow-hidden">

            <IndustryHero svgPath="/HeroSectionImg/SmartDelivery.svg" />
            <CaseStudiesIntroBanner
                title="How Smart Delivery Achieved 3.1x Organic Traffic Growth with SEO & SMO Optimization"
                subtitle=""
                imageSrc="/logo/SmartDelivery.svg"
                imageAlt="Board Games"
            />

            <CaseStudiesSkewSatusCardsSection clients={clients} skewCards={skewCards} clientIntroPara="Smart Delivery, a delivery and logistics-focused brand, needed stronger organic visibility, local discovery, and brand recall across search and social channels. While the business had a clear service offering, its digital presence was not capturing enough high-intent traffic from users actively searching for delivery solutions." />

            <section className=" relative overflow-hidden border-y border-[#EDEDED] ">
                < VideoSection src="/video/SmartDelievery.mp4" poster="/Thumbnails/SmartDelivery.png" />
            </section>



            <TheChallengeScrollSection
                sectionTitle={{
                    title: "The Challenge",
                    description: [
                        "Smart Delivery was operating in a competitive, intent-heavy category where users often make quick decisions based on search visibility, local presence, credibility and ease of discovery.",

                        "The brand had service-market relevance, but its digital growth engine was under-leveraged. Organic visibility was limited, local search presence needed improvement, keyword rankings were not strong enough across high-value terms and social channels needed better optimization to support brand trust."
                    ],
                }}
                rightColumnItems={[
                    {
                        heading: "Weak Organic Search Visibility",
                        text: "The website was not ranking consistently across relevant search queries, limiting its ability to capture high-intent users.",
                    },
                    {
                        heading: "Limited Keyword Footprint",
                        text: "A narrow ranking base was restricting the website’s visibility across broader delivery-related search journeys.",

                    },
                    {

                        heading: "Low SERP Click-Through Rate",
                        text: "Existing page titles and meta descriptions were not compelling enough to convert impressions into website visits.",
                    },
                    {

                        heading: "Underdeveloped Authority Profile",
                        text: "The backlink profile required significant strengthening to improve domain trust and competitive search performance. ",
                    },
                    {
                        heading: "Local Discovery Gaps",
                        text: "Business listings, citations, map visibility, and local keyword presence needed to be improved for local visibility.",
                    },
                    {

                        heading: "Inconsistent Social Optimization",
                        text: "Brand touchpoints needed clearer optimization to support credibility, consistency and discovery beyond search.",
                    },
                ]}
            />
            <div className=" py-16 lg:py-24  relative overflow-hidden">

                <CaseStudiesMutiPurposeZigZagSection
                    sectionTitle="Our Strategic Approach"
                    sectionDescription="Instead of treating SEO as a checklist, MMB built a performance-led roadmap around visibility, authority, click-through improvement and local discoverability. The goal was to help Smart Delivery show up more often, appear more credible and attract users with stronger intent."

                    cards={[
                        {
                            iconSrc: "/icons/StrategicApproach-icon/SmartDelivery (1).svg",
                            iconAlt: "Search Visibility  ",
                            title: "Search-Led Growth Strategy",
                            description: "Mapped commercial, branded, service-led, and local keywords to priority pages to improve ranking potential and demand capture.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/SmartDelivery (2).svg",
                            iconAlt: "Technical SEO Foundation",
                            title: "Technical SEO Foundation  ",
                            description: "Improved site-level SEO hygiene, metadata structure, indexing readiness, headings, internal links, and search engine accessibility.",
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/SmartDelivery (5).svg",
                            iconAlt: "Content Growth  ",
                            title: "On-Page Optimization Framework ",
                            description: "Refined page content, title tags, meta descriptions, keyword usage, and content relevance to improve rankings and CTR.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/SmartDelivery (3).svg",
                            iconAlt: "Analytics & Optimization  ",
                            title: "Local SEO Visibility Framework",
                            description: "Optimized business listings, built local citations, improved map visibility, and supported location-based keyword discovery.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/SmartDelivery (6).svg",
                            iconAlt: "Authority Building Framework",
                            title: "Authority Building Framework",
                            description: "Built backlinks, referring domains, authority links, and brand mentions to improve search credibility and competitive strength.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/SmartDelivery (4).svg",
                            iconAlt: "Authority Building Framework",
                            title: "Social Media Optimization Layer",
                            description: "Improved social profiles, content hygiene, brand consistency, and platform-level optimization to support stronger digital recall.",
                            contentAlign: "center"
                        },

                    ]}
                />

            </div>

            <div className="custom-container pb-16 lg:pb-20 xl:pb-24">


                <CaseStudyEngageMentModel
                    leftImage="/hero-bg/officemeet.jpg"
                    cards={[
                        {
                            title: "Growth-as-a-Service",
                            description: [
                                "A structured SEO and SMO engagement focused on measurable visibility, authority and traffic growth.",
                            ],
                        },
                        {
                            title: "Dedicated Growth Pod ",
                            description: [
                                "SEO strategist, content specialist, off-page SEO resource, local SEO specialist, social media resource and performance analyst.",
                            ],
                        },

                        {
                            title: "Reporting Rhythm ",
                            description: [
                                "Keyword movement, organic users, impressions, CTR, backlinks, local visibility and social optimization progress were tracked through regular reporting.",
                            ],
                        },
                        {
                            title: "Optimization Layer",
                            description: [
                                "Continuous refinements across on-page SEO, metadata, local listings, backlinks, keyword targeting and social media assets.",
                            ],
                        },


                    ]}


                />




            </div>


            <div className="section-background-filler py-16 space-y-16">
                <CaseStudiesNewMegaCardSection
                    sectionTitle={{
                        title: "What We Did ",
                        description: "By combining SEO, local search optimization, authority building, and SMO, we helped Smart Delivery build a stronger digital growth foundation.",
                        align: "left"
                    }}
                    cards={[
                        {
                            title: "Technical SEO",
                            description:
                                "Improved SEO hygiene, metadata structure, indexing readiness, headings, and internal linking.",
                        },
                        {
                            title: "Keyword Strategy",
                            description:
                                "Expanded keyword targeting across commercial, service-led, branded, and local search intent.",
                        },
                        {
                            title: "On-Page SEO",
                            description:
                                "Optimized page titles, meta descriptions, content relevance, search snippets, and CTR signals.",
                        },
                        {
                            title: "Local SEO",
                            description:
                                "Created business listings, built citations, improved map visibility, and strengthened local keyword presence.",
                        },
                        {
                            title: "Authority Building",
                            description:
                                "Generated backlinks, referring domains, authority links, and brand mentions to improve trust signals.",
                        },
                        {
                            title: "SMO",
                            description:
                                "Optimized social profiles, brand messaging, platform consistency, and content presentation.",
                        },
                        {
                            title: "Performance Tracking",
                            description:
                                "Monitored organic users, sessions, impressions, CTR, keyword rankings, backlinks, and map visibility.",
                        },

                    ]}

                />

                <div className="mb-12 px-6 md:px-auto xl:my-12">
                    <RedRibbonBanner title="Key Insight:">
                        Smart Delivery did not just need more traffic. It needed a more reliable discovery engine. By strengthening SEO, local visibility, authority and social presence together, MMB helped the brand turn search visibility into measurable growth.
                    </RedRibbonBanner>
                </div>

                <ImageMarquee
                    images={[
                        { src: "/CaseStudiesFolder/ShowCaseImg/SmartDelivery-ShowCaseImages/ShowCaseImg (2).png", alt: "Jem Jem case study" },
                        { src: "/CaseStudiesFolder/ShowCaseImg/SmartDelivery-ShowCaseImages/ShowCaseImg (1).png", alt: "Jem Jem case study" },
                        { src: "/CaseStudiesFolder/ShowCaseImg/SmartDelivery-ShowCaseImages/ShowCaseImg (3).png", alt: "Jem Jem case study" },
                    ]}
                    speed={20}
                    direction="left"
                    pauseOnHover={false}
                />


            </div>



            <section className="py-16 lg:py-20 custom-container">
                <SectionTitle
                    title="The Results "
                    description="The SEO and SMO engagement delivered clear improvements across organic traffic, search visibility, keyword rankings, authority and local discovery."
                    align="center"
                    highlightSubtitle={true}
                />


                <div className="w-full overflow-x-auto mt-6">
                    <div className="inline-block min-w-full align-middle">
                        <div className="grid grid-cols-1  gap-6">

                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 !text-left ">
                                <UniversalTable
                                    title="SEO Growth Impact"
                                    headers={["Metric", "Before", "After", "Growth"]}
                                    rows={[
                                        [
                                            "Monthly Organic Users",
                                            "1,250",
                                            "3,875",
                                            "+210%",
                                        ],
                                        [
                                            "Organic Sessions",
                                            "1,800",
                                            "5,420",
                                            "+201%",
                                        ],
                                        [
                                            "Website Impressions",
                                            "18,500",
                                            "72,400",
                                            "+291%",
                                        ],
                                        [
                                            "Average CTR",
                                            "1.8%",
                                            "4.9%",
                                            "+172%",
                                        ],
                                    ]}
                                    ribbonTitle="Key Insight:"
                                    ribbonContent="Improved search visibility brought more qualified users into the funnel, while stronger metadata and content optimization helped convert impressions into clicks."
                                />

                                <UniversalTable
                                    title="Keyword Ranking Improvements"
                                    headers={["Ranking Position", "Before", "After"]}
                                    rows={[
                                        [
                                            "Top 3 Keywords",
                                            "3",
                                            "18",
                                        ],
                                        [
                                            "Top 10 Keywords",
                                            "11",
                                            "42",
                                        ],
                                        [
                                            "Top 20 Keywords",
                                            "22",
                                            "76",
                                        ],
                                        [
                                            "Total Ranking Keywords",
                                            "68",
                                            "214",
                                        ],
                                    ]}
                                    ribbonTitle="Visibility Impact:"
                                    ribbonContent="Smart Delivery moved from limited keyword presence to broader visibility across search journeys where users actively look for delivery-related services."
                                />

                            </div>


                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 !text-left ">
                                <UniversalTable
                                    title="Authority Building Impact"
                                    headers={["Metric", "Before", "After"]}
                                    rows={[
                                        [
                                            "Total Backlinks",
                                            "145",
                                            "1180",
                                        ],
                                        [
                                            "Referring Domains",
                                            "28",
                                            "124",
                                        ],
                                        [
                                            "Authority Links Acquired",
                                            "12",
                                            "87",
                                        ],
                                        [
                                            "Brand Mentions",
                                            "15",
                                            "96",
                                        ],
                                    ]}
                                    ribbonTitle="Authority Trigger:"
                                    ribbonContent="A stronger backlink and referring domain profile helped reinforce Smart Delivery’s search trust and improved its ability to compete across relevant keyword categories."
                                />


                                <UniversalTable
                                    title="Local SEO Performance"
                                    headers={["Metric", "Result"]}
                                    rows={[
                                        [
                                            "Business Listings Created",
                                            "27",
                                        ],
                                        [
                                            "Local Citations Built",
                                            "75+",
                                        ],
                                        [
                                            "Map Visibility Increase",
                                            "138%",
                                        ],
                                        [
                                            "Local Keyword Rankings Improved",
                                            "65+ Keywords",
                                        ],
                                    ]}
                                    ribbonTitle="Local Growth Trigger:"
                                    ribbonContent="Stronger local search signals helped Smart Delivery become more discoverable to users searching within relevant service areas."
                                />

                            </div>
                            <UniversalTable
                                title="The Impact"
                                headers={["Growth Area", "Business Impact"]}
                                rows={[
                                    [
                                        "Organic Visibility",
                                        "291% increase in impressions and stronger discovery across search.",
                                    ],
                                    [
                                        "Traffic Growth",
                                        "3.1x increase in organic website traffic.",
                                    ],
                                    [
                                        "Keyword Authority",
                                        "214 ranking keywords achieved with stronger Top 3, Top 10, and Top 20 visibility.",
                                    ],
                                    [
                                        "Search Engagement",
                                        "Average CTR improved from 1.8% to 4.9%.",
                                    ],
                                    [
                                        "Brand Authority",
                                        "Backlinks grew from 145 to 1,180 and referring domains increased from 28 to 124.",
                                    ],
                                    [
                                        "Local Discovery",
                                        "Map visibility increased by 138% with 65+ local keyword rankings improved.",
                                    ],
                                    [
                                        "Social Presence",
                                        "SMO improvements supported brand consistency, credibility, and digital recall.",
                                    ],
                                ]}
                                ribbonTitle="Key Insight:"
                                ribbonContent="A unified SEO and SMO strategy helped Smart Delivery move from scattered digital visibility to a stronger, measurable and more scalable organic growth engine."
                            />
                        </div>
                    </div>
                </div>

            </section>





            <CommentSection quote="The MMB team gave us a structured growth strategy instead of isolated SEO activities. Within months, we saw stronger search visibility, better local presence, and a noticeable increase in qualified organic traffic. Their proactive communication and data-driven approach made them feel like an extension of our own team." name="Smart Delivery" avatarSrc={""} />

            <ToolsStack
                title="Our Tech Stack & Tools "
                description="Our stack consolidated SEO, analytics, local optimization, and reporting tools to keep every growth initiative data-led and performance-focused. "
                categories={[
                    {
                        title: "SEO & Keyword Research",
                        items: [
                            "Ahrefs",
                            "SEMrush",
                            "Google Keyword Planner",
                            "Google Search Console",
                        ],
                    },
                    {
                        title: "Technical SEO Optimization",
                        items: [
                            "Screaming Frog",
                            "GTmetrix",
                            "Google Search Console",
                        ],
                    },
                    {
                        title: "Analytics & Tracking",
                        items: [
                            "GA4",
                            "Google Tag Manager",
                            "Looker Studio",
                        ],
                    },
                    {
                        title: "Local SEO Optimization",
                        items: [
                            "Google Business Profile",
                            "local citation platforms",
                            "listing management tools",
                        ],
                    },
                    {
                        title: "Authority Building",
                        items: [
                            "Backlink analysis tools",
                            "Outreach tracking",
                            "Brand mention monitoring",
                        ],
                    },
                    {
                        title: "Social Media Optimization",
                        items: [
                            "Meta Business Suite",
                            "Platform analytics",
                            "Content planning tools",
                        ],
                    },
                    {
                        title: "Reporting & Dashboards",
                        items: [
                            "Looker Studio",
                            "Google Sheets",
                            "Custom KPI dashboards",
                        ],
                    },
                    {
                        title: "Collaboration & Project Management",
                        items: [
                            "Slack",
                            "Trello",
                            "Google Drive",
                        ],
                    },
                ]}
                withBackground={true}
            />


            <div className="pb-0 md:pb-16 xl:pb-20 relative overflow-hidden">
                <CTABanner
                    title="Ready to Build a Stronger Organic Growth Engine?"
                    description="Smart SEO helps your brand get discovered, trusted and chosen by the right audience."
                    buttonText="Book Your Growth Consultation"
                    // buttonOnClick={handleCTAButtonClick}
                    bgColor="#313866"
                    textColor="#fff"
                    buttonVariant="primary"
                />
            </div>
            <RelatedCaseStudies />
        </main >
    );
}